<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.name">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.name }}</p>
      <small>({{activeUserInfo.userRole}}) {{ activeUserInfo.company }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/profile')">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profil</span>
          </li>
          <template v-if="$store.state.is_admin()">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Mes tâches</span>
            </li>

            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
              <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Chat</span>
            </li>
          </template>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Paramètres</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Déconnexion</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    isAdmin() {
      return this.$store.state.AppActiveUser.userRole === 'admin'
    }
  },
  methods: {
    logout() {
      this.$http.post('/cex/logout').then(() =>{
        localStorage.setItem("userInfo", '')
        localStorage.setItem('access', '')
        this.$router.push('/login')
      }).catch((error) =>{
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    localStorage.setItem("userInfo", '')
                    localStorage.setItem('access', '')
                    this.$router.push('/login')
                }
            })
    },
  }
}
</script>
